import React from "react";
import { Lightbulb, HelpCircle, MessageSquare, ThumbsUp, Pin, Lock, CheckCircle2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDay } from "./ideaUtils";

export function PostCard({ p, onOpen }) {
  const Q = p.type === "question";
  return (
    <li>
      <button onClick={() => onOpen(p.id)} className="w-full text-left rounded-xl border border-slate-200 bg-white p-4 hover:border-[#006090] hover:shadow-sm transition-[box-shadow,border-color]" data-testid={`ideas-post-${p.id}`}>
        <div className="flex flex-wrap items-center gap-2 text-[11px] font-semibold">
          <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 ${Q ? "bg-[#006090]/10 text-[#006090]" : "bg-amber-100 text-amber-800"}`}>{Q ? <HelpCircle className="w-3 h-3" /> : <Lightbulb className="w-3 h-3" />}{Q ? "Question" : "Idea"}</span>
          {p.category_name && <span className="rounded-full bg-slate-100 text-slate-600 px-2 py-0.5">{p.category_name}</span>}
          {p.pinned && <span className="inline-flex items-center gap-1 text-[#0D9488]"><Pin className="w-3 h-3" />Pinned</span>}
          {p.closed && <span className="inline-flex items-center gap-1 text-slate-500"><Lock className="w-3 h-3" />Closed</span>}
          {Q && p.accepted_comment_id && <span className="inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 className="w-3 h-3" />Answered</span>}
          {p.status === "removed" && <span className="text-rose-600">Removed</span>}
        </div>
        <p className="mt-1.5 font-semibold text-slate-900">{p.title}</p>
        <p className="mt-1 text-xs text-slate-500 flex flex-wrap gap-x-3">
          <span>{p.author_name} · {fmtDay(p.created_at)}</span>
          <span className="inline-flex items-center gap-1"><MessageSquare className="w-3 h-3" />{p.comment_count}</span>
          <span className="inline-flex items-center gap-1"><ThumbsUp className="w-3 h-3" />{p.helpful_count}</span>
          <span>Active {fmtDay(p.last_activity_at)}</span>
        </p>
      </button>
    </li>
  );
}

export function DiscussionList({ data, onOpen, onPage, onNew, readOnly, filtered }) {
  if (!data) return <p className="text-sm text-slate-400">Loading…</p>;
  if (!data.items.length) return (
    <div className="rounded-2xl border border-dashed border-slate-300 p-8 text-center" data-testid="ideas-empty">
      <p className="font-semibold text-slate-800">{filtered ? "No discussions match these filters" : "No discussions yet"}</p>
      <p className="text-sm text-slate-500 mt-1">Be the first to share something that works, or ask your peers a question.</p>
      {!readOnly && <Button onClick={onNew} className="mt-3 bg-brand hover:bg-brand-strong" data-testid="ideas-empty-new"><Plus className="w-4 h-4 mr-1" />Share an Idea / Ask a Question</Button>}
    </div>);
  const pages = Math.ceil(data.total / data.page_size);
  return (
    <>
      <ul className="space-y-2" data-testid="ideas-list">{data.items.map((p) => <PostCard key={p.id} p={p} onOpen={onOpen} />)}</ul>
      {pages > 1 && <div className="flex items-center justify-center gap-3 mt-3 text-sm" data-testid="ideas-pager">
        <Button variant="outline" size="sm" disabled={data.page <= 1} onClick={() => onPage(data.page - 1)}>Previous</Button>
        <span>Page {data.page} of {pages}</span>
        <Button variant="outline" size="sm" disabled={data.page >= pages} onClick={() => onPage(data.page + 1)}>Next</Button></div>}
    </>
  );
}
